export enum CallStatus {
  Abandoned = 'abandoned',
  Completed = 'completed',
  InProgress = 'in-progress',
  Intro = 'intro',
  Unanswered = 'unanswered',
  Waiting = 'waiting',
}
